import { styled } from '@clickcease/cc-client-components-lib'

export const DetailedReportWrapper = styled('div', {})

export const IPsTableWrapper = styled('div', {
  backgroundColor: '$white',
  boxShadow: '0 2px 4px 0 #0000000d',
  borderTopLeftRadius: '.8em',
  borderTopRightRadius: '.8em',
  '& > div:nth-child(3)': {
    maxHeight: '70vh',
    '& table > thead > th': {
      padding: '0px !important',
    },
  },
  variants: {
    isLaptop: {
      true: {
        '& > div:nth-child(3)': {
          maxHeight: '57vh',
        },
      },
    },
    isLoadingBlockedQuery: {
      true: {
        '& > div:nth-child(3)': {
          maxHeight: '88vh',
        },
      },
    },
  },
  compoundVariants: [
    {
      isLaptop: true,
      isLoadingBlockedQuery: true,
      css: {
        '& > div:nth-child(3)': {
          maxHeight: '83vh',
        },
      },
    },
  ],
})

export const IPsTableTitleWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '10px',
  borderBottom: '1px solid $separatorColor',
  lineHeight: '28px',
  padding: '20px 20px 5px 10px',
})

export const LoaderWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
})

export const IPsTableTitle = styled('h2', {
  fontWeight: '$r',
  fontSize: '$h3',
  padding: '5px 10px',
  margin: '0px',
})

export const StyledTh = styled('th', {
  borderBottom: 'none !important',
  fontWeight: '$sb',
  width: '95px',
  padding: 'unset !important',
  variants: {
    firstOfKind: {
      true: {
        textAlign: 'center',
        padding: '0px 0px 0px 16px !important',
      },
    },
  },
})

export const StyledTr = styled('tr', {
  '&:hover': {
    backgroundColor: '#FFF5F9',
  },
  variants: {
    firstRow: {
      true: {
        borderTop: '2px solid #E6E8F0',
      },
    },
  },
})

export const StyledTd = styled('td', {
  borderBottom: '1px solid $separatorColor !important',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '50px',
  padding: '20px 0px !important',
  color: '$textColor',
  fontSize: '$md',
  fontWeight: '$l',
  variants: {
    modifiedPadding: {
      true: {
        padding: '20px 0px 20px 30px !important',
      },
    },
  },
})

export const ActionWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '8px',
})

export const FlagStyles = {
  marginRight: '10px',
  width: '22px',
  height: '22px',
}
